import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CfaLoadingModule } from '@emm/core/modules/cfa-loading/cfa-loading-module';
import { CfaDataTable } from './cfa-data-table.component';
import { MatCardModule } from '@angular/material/card';
import { MatSliderModule } from '@angular/material/slider';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
    imports: [
        CommonModule,
        CfaLoadingModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatFormFieldModule,
        MatIconModule,
        MatSliderModule,
        MatSnackBarModule,
        ScrollingModule
    ],
    declarations: [
        CfaDataTable
    ],
    exports: [
        CfaDataTable
    ]
})
export class CfaDataTableModule {}
